/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResearchPrompt } from './ResearchPrompt';
import {
    ResearchPromptFromJSON,
    ResearchPromptFromJSONTyped,
    ResearchPromptToJSON,
    ResearchPromptToJSONTyped,
} from './ResearchPrompt';

/**
 * A research session
 * @export
 * @interface ResearchSession
 */
export interface ResearchSession {
    /**
     * 
     * @type {string}
     * @memberof ResearchSession
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ResearchSession
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof ResearchSession
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ResearchSession
     */
    createdAt: string;
    /**
     * 
     * @type {Array<ResearchPrompt>}
     * @memberof ResearchSession
     */
    researchPrompts: Array<ResearchPrompt>;
}

/**
 * Check if a given object implements the ResearchSession interface.
 */
export function instanceOfResearchSession(value: object): value is ResearchSession {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('researchPrompts' in value) || value['researchPrompts'] === undefined) return false;
    return true;
}

export function ResearchSessionFromJSON(json: any): ResearchSession {
    return ResearchSessionFromJSONTyped(json, false);
}

export function ResearchSessionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResearchSession {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'userId': json['user_id'],
        'name': json['name'] == null ? undefined : json['name'],
        'createdAt': json['created_at'],
        'researchPrompts': ((json['research_prompts'] as Array<any>).map(ResearchPromptFromJSON)),
    };
}

export function ResearchSessionToJSON(json: any): ResearchSession {
    return ResearchSessionToJSONTyped(json, false);
}

export function ResearchSessionToJSONTyped(value?: ResearchSession | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'user_id': value['userId'],
        'name': value['name'],
        'created_at': value['createdAt'],
        'research_prompts': ((value['researchPrompts'] as Array<any>).map(ResearchPromptToJSON)),
    };
}

